import React        from 'react';
import PropTypes    from 'prop-types';
import Header       from './Header';
import Block        from '../Block';
import ButtonRow    from './ButtonRow';
import Translations from '../../../utils/Translations';
import TileGrid     from '../../TileGrid/TileGrid';
import Flux         from '../../../flux/Flux';
import { trackClick } from '../../../utils/GAHelper';

const GRID_ID = 'home-favorites-grid';

class FavoritesBlock extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isTeaserShown: Flux.Teaser.hasTeasers(),
			window:        Flux.Browser.getWindowSize(),
		};

		this.onTeasersChange = this.onTeasersChangeHandler.bind(this);
		this.onResize        = this.onResizeHandler.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addWindowResizeListener(this.onResize);
		Flux.Teaser.addTeasersChangeListener(this.onTeasersChange);
		Flux.TileGrid.toggleGridCrop(GRID_ID, this._shouldCrop());
	}

	componentWillUnmount() {
		Flux.Teaser.removeTeasersChangeListener(this.onTeasersChange);
		Flux.Browser.removeWindowResizeListener(this.onResize);
	}

	onTeasersChangeHandler() {
		this.setState({
			isTeaserShown: Flux.Teaser.hasTeasers(),
		});
	}

	onResizeHandler() {
		this.setState({
			window: Flux.Browser.getWindowSize(),
		});

		Flux.TileGrid.toggleGridCrop(GRID_ID, this._shouldCrop());
	}

	_hasTiles() {
		return null !== this.props.tiles
			&& this.props.tiles.hasOwnProperty('initialTiles')
			&& this.props.tiles.initialTiles.length > 0;
	}

	_shouldCrop() {
		if (!this._hasTiles()) {
			return false;
		}

		// 5 cols
		const crop5 = this.state.window.width >= Flux.Constants.TileGridBreakpoints.FiveCols
			&& this.props.tiles.initialTiles.length > 10     // starting from the 3rd row
			&& this.props.tiles.initialTiles.length % 5 > 0; // starting from the 3rd row

		// 4 cols
		const crop4 = this.state.window.width >= Flux.Constants.TileGridBreakpoints.ThreeCols
			&& this.props.tiles.initialTiles.length > 8      // starting from the 3rd row
			&& this.props.tiles.initialTiles.length % 4 > 0; // starting from the 3rd row

		const crop3 = this.state.window.width >= Flux.Constants.TileGridBreakpoints.ThreeCols
			&& this.state.window.width < Flux.Constants.TileGridBreakpoints.FourCols
			&& this.props.tiles.initialTiles.length > 6      // starting from the 3rd row
			&& this.props.tiles.initialTiles.length % 3 > 0; // starting from the 3rd row

		const crop2 = this.state.window.width < Flux.Constants.TileGridBreakpoints.ThreeCols;

		return crop5 || crop4 || crop3 || crop2;
	}

	render() {
		if (!(this.props.isGuestLoggedIn && this._hasTiles())) {
			return null;
		}

		const cta = Translations
			.get('HomepageV2FavoritesAll')
			.replace(':count', this.props.total);

		const noBorder = this.state.isTeaserShown ? ' has-no-border' : '';

		return (
			<Block className={"favorite" + noBorder} idName="favorite-block">
				<Header
					title={Translations.get('HomepageV2FavoritesTitle')}
					hasCount={true}
					count={this.props.online}
					countLabel={Translations.get('HomepageV2FavoritesPlural')}
					icon="-icon-heart-full"
				/>
				<TileGrid
					tileGridId={GRID_ID}
					tiles={this.props.tiles.initialTiles}
					gridConfig={this.props.tiles}
					guestIsLoggedIn={this.props.isGuestLoggedIn}
					landingPageResults={true}
					crop={this._shouldCrop()}
					useResponsiveCols={false}
				/>
				<ButtonRow cta={cta} link={this.props.link} callback={() => trackClick('fav', this.props.link)} />
			</Block>
		);
	}
}

FavoritesBlock.propTypes = {
	tiles:           PropTypes.object,
	total:           PropTypes.number,
	online:          PropTypes.number,
	link:            PropTypes.string.isRequired,
	isMobile:        PropTypes.bool,
	isGuestLoggedIn: PropTypes.bool,
};

FavoritesBlock.defaultProps = {
	total:           0,
	online:          0,
	isMobile:        false,
	isGuestLoggedIn: false,
};

export default FavoritesBlock;
